import axios from "../helper/axios";
import { create } from "zustand";

const useNuJobsStore = create((set,get) => ({

  openJds: [],
  similaryJds: [],
  lastJDsReq:null,
  lastSearchReq: [],
  totalOpenJds: 0,
  applyNowPopUpRouting: false,
  applyNowJd: null,
  currentSearch: null,
  searchMetaData: null,
  hiringCompanies:[],
  upcomingEvents:[],
  selectedEvent: null,
  selectedEventJD:[],

  getUserAnalytics: async (params = {}) => {
    try {
      const response = await axios.get("/nujobsUsersAnalytics", {
        params,
      });

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  getOSAllJds: async (body,resultHandler) => {
        try {       
            //console.log("nujobsGetAllJds Req",body);
            set({ lastJDsReq: null });
            const response = await axios.post(
                `nujobsGetAllJds`,body
            );

            //store the current search with page number
            set({ currentSearch: body });

            set({ openJds: response.data.data });
            set({ totalOpenJds: response.data.totalOpenJds });
            set({ similaryJds: response.data.similarjds });
            set({ searchMetaData: response.data.metadata });
            set({ lastJDsReq: response.data.lastJDsReq });

            //remove the pending sync from local storage after successful API call
            localStorage.removeItem("NuJobsPendingSync");

            //console.log("getOSAllJds Response:", response.data.name);
            //console.log("Open Jobs:", response.data.data);
            //console.log("Total Open Jobs:", response.data.totalOpenJds);
            //console.log("Similar Jobs:", response.data.similarjds);
            //console.log(response.data.lastJDsReq);
             if(resultHandler) resultHandler(response.data.totalOpenJds)
        } catch (error) {
            console.log(error);
            localStorage.removeItem("NuJobsPendingSync");
        }
    },

  nuJobsPendingSychMetaData: async (body, cb) => {
        try {       
            console.log("nuJobsPendingSychMetaData Req",body);
            const response = await axios.post(
                `nuJobsPendingSychMetaData`,body
            );            
            //remove the pending sync from local storage after successful API call
            localStorage.removeItem("NuJobsPendingSync");
            console.log(response.data.name);
            
            //get new data after sync
            if(cb) cb()

        } catch (error) {
            console.log(error);
            localStorage.removeItem("NuJobsPendingSync");
        }
    },
  nuJobsGetLastSearch: async () => {
        try {
            console.log("nuJobsGetLastSearch",);
            const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
            const response = await axios.post(
                `/nujobsGetLastReq/${userData.nujoid}/${userData.nujuid}`
            );            
            set({ lastSearchReq: response.data.data });
            console.log(response.data.name);
            console.log(response.data.data);
        } catch (error) {
            console.log(error);
        }
    },

  nuJobsEmployerWhoisHiring: async (timestamp) => {
        try {
            //console.log("nuJobsEmployerWhoisHiring");
            const response = await axios.get(
                `/nuJobsEmployerWhoisHiring/${timestamp}`
            );
            set({ hiringCompanies: response.data.hiringCompanies });
            console.log(response.data.name);
            console.log("Hiring Companies",response.data);
        } catch (error) {
            console.log(error);
        }
    },
  nuJobsUpcomingEvents: async (timestamp) => {
        try {
            //console.log("nuJobsUpcomingEvents");
            const response = await axios.get(
                `/nuJobsUpcomingEvents/${timestamp}`
            );
            set({ upcomingEvents: response.data.data });
            console.log(response.data.name);
            console.log(response.data.data);
        } catch (error) {
            console.log(error);
        }
    },   
  nuJobsGetJDandEvent: async (qhoid,qhjid,cb) => {
        try {
            console.log("nuJobsGetJDandEvent");
            const response = await axios.get(
                `/getjdandeventbyid/${qhoid}/${qhjid}`
            );
            set({ selectedEvent: response.data.data });
            set({ selectedEventJD: response.data.jd });
            console.log(response.data.name);
            console.log(response.data.data);
            console.log(response.data.jd);
            if(cb) cb(qhoid,qhjid)
        } catch (error) {
            console.log(error);
        }
    },       
    
  resetCurrentSearch: () => {
    set({ currentSearch: null });
  },
  setApplyNowPopRouting: (jdInfo) => {
    set({ applyNowPopUpRouting: true });
    set({ applyNowJd: jdInfo });
  },  
  resetApplyNowPopRouting: () => {
    set({ applyNowPopUpRouting: false });
    set({ applyNowJd: null });
  },  

  setSearchMetaData: (item) => {
    if(item && item.length > 0){
        set({ searchMetaData: item });
    }
  },   
  toggleMetaDataFav: (id, isFavorite) => {
    if(get().searchMetaData && get().searchMetaData.length > 0){
        const updatedMetaData = get().searchMetaData
        updatedMetaData[id].isFavorite = isFavorite
        set({ searchMetaData: updatedMetaData });
    }
  }, 
 
  setMetaDataViewed: (id) => {
    set((state) => {
      if (!state.searchMetaData || state.searchMetaData.length === 0) {
        return {};
      }
      const updatedMetaData = [...state.searchMetaData];
      updatedMetaData[id] = {
        ...updatedMetaData[id],
        isViewed: true,
      };
      console.log("New MetaData",updatedMetaData)
      return {
        searchMetaData: updatedMetaData,
      };
    });
  },   
  setMetaDataApplied: (id) => {
    if(get().searchMetaData && get().searchMetaData.length > 0){
        const updatedMetaData = get().searchMetaData
        updatedMetaData[id].isApplied = true
        set({ searchMetaData: updatedMetaData });
    }
  },   
  clearOSJD: () => {
    //console.log("clearJD");
    set({ openJds: null });
    set({ similaryJds: null });
  },

  nujobsUpdateProfile: async (body) => {
    try {
      console.log("nuJobsUpdateUserInfo", body);
      const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
      const response = await axios.put(
        `/nuJobsUpdateUserInfo/${userData.nujoid}/${userData.nujuid}`,
        body,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      console.log("update response", response.data.user);
      try {
        localStorage.setItem(
          "nujobsUserDetails",
          JSON.stringify(response.data.user),
        );
      } catch (e) {
        console.log("Failed to update localStorage", e);
      }
    } catch (error) {
      console.log(error);
    }
  },
  
}));

export default useNuJobsStore;
